module.exports = __webpack_public_path__ + "static/Allocation-Details-fe93e4648c5161743bb3ce5ca1e58744.png";